var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDoubleCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.529 5.23666C14.8585 5.55795 14.8652 6.08555 14.5439 6.41508L6.64386 14.5178C6.01706 15.1607 4.99187 15.1607 4.36507 14.5178L1.07016 11.1384C0.748869 10.8089 0.755552 10.2813 1.08508 9.95998C1.41462 9.63869 1.94221 9.64537 2.2635 9.9749L5.50446 13.299L13.3506 5.25159C13.6719 4.92206 14.1995 4.91537 14.529 5.23666ZM5.55841 13.3544L5.5583 13.3542L5.55841 13.3544ZM18.9152 5.23666C19.2448 5.55795 19.2515 6.08555 18.9302 6.41508L11.0301 14.5178C10.7088 14.8474 10.1812 14.8541 9.85168 14.5328C9.52215 14.2115 9.51546 13.6839 9.83675 13.3544L17.7368 5.25159C18.0581 4.92206 18.5857 4.91537 18.9152 5.23666Z",
    fill: "#002CFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDoubleCheck);
export default __webpack_public_path__ + "static/media/iconDoubleCheck.ab67ee5faa1e6d0daf230e5daab97049.svg";
export { ForwardRef as ReactComponent };